<template>
  <div>
    <v-stepper v-model="e1" v-if="content">
      <v-stepper-header>
        <v-stepper-step color="amber" :complete="e1 > 1" step="1" @click="el = 1">Details</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="e1 > 2" step="2" @click="el = 2">Choose 4 Words</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" :complete="e1 > 3" step="3" @click="el = 3">Choose 16 Images</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step color="amber" step="4" @click="el = 4">Arrange</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="5">
              <h1>{{ content.exercise_tiles_survey.step1.title }}</h1>
              <p v-for="(item, index) in content.exercise_tiles_survey.step1.description" :key="index" v-html="item" />

            </v-col>
            <v-col cols="6" offset="1">
              <v-form v-model="valid" ref="detailsForm">
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="exercise.firstName" :label="content.exercise_tiles_survey.step1.question1"
                      color="amber"></v-text-field>
                    <v-text-field v-model="exercise.lastName" :label="content.exercise_tiles_survey.step1.question2"
                      color="amber"></v-text-field>
                    <v-text-field v-model="exercise.jobTitle" :label="content.exercise_tiles_survey.step1.question3"
                      color="amber"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-btn class="amber" light :disabled="!valid" @click="nextStep">Next step</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          <bottom-navigation :save="false" :next="valid" :prev="false" :gridView="false" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep">
          </bottom-navigation>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-row>
            <v-col cols="6" class="mb-12">
              <h2 v-text="content.exercise_tiles_survey.step2.title"></h2>
              <p v-for="(item, index) in content.exercise_tiles_survey.step2.description" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <v-row dense v-if="gridView && words.length >= 1" class="mb-10">
            <!-- <v-col v-for="card in words" :key="card.id" :cols="2"> -->
            <div v-for="card in words" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id"
                :class="{ selected: card.selected, smaller: computedZoomClass }" @click="selectCard(card.id)"
                :hover="true" :elevation="1">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else-if="words && words.length >= 1"
            class="align-center mb-10">
            <v-carousel-item v-for="card in words" :key="card.id">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10" :hover="true">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="false" :next="true" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              Selected words
              <v-chip :class="wordsCheck" class="white--text">{{
                selectedWords.length
              }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row class="mb-12">
            <v-col cols="6">
              <h2 v-text="content.exercise_tiles_survey.step3.title"></h2>
              <p v-for="(item, index) in content.exercise_tiles_survey.step3.description" :key="index" v-text="item" />
              <p>Your selected words:</p>
              <v-chip v-for="word in selectedWords" :key="word.title" class="white black--text mx-1">{{ word.title
              }}</v-chip>
            </v-col>
            <v-col cols="6">
              <p>Filter</p>
              <v-select :items="dropdownCategories" v-model="filters" @change="changeFilter"></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="gridView" class="mb-10">
            <!-- <v-col v-for="card in images" :key="card.id" :cols="2"> -->
            <div v-for="card in images" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                </div>

                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else class="align-center">
            <v-carousel-item v-for="card in images" :key="card.id" class="mb-10">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <!-- <div
									class="card__inner"
									:style="{ backgroundImage: `url(${card.src})` }"
									v-if="card.type == 'Image'"
								></div> -->
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                  <!-- <ix-img class="imgix" :src="card.src" sizes="30vw" /> -->
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="false" :next="true" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              Selected images
              <v-chip :class="imagesCheck" class="white--text">{{
                selectedImages.length
              }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="4" class="">
          <v-row dense>
            <v-col cols="6">
              <h2 v-text="content.exercise_tiles_survey.step4.title"></h2>
              <p v-for="(item, index) in content.exercise_tiles_survey.step4.description" :key="index" v-text="item" />
            </v-col>
          </v-row>

          <TilesGridArranger v-if="shortlist && shortlist.length" :tiles="shortlist" v-model="gridSlots"
            :initial-cell-size="gridCellSize" :initial-cols="gridCols" @update-cell-config="onUpdateCellConfig" />

          <bottom-navigation :save="true" save-label="SAVE" :next="false" :prev="true" :gridView="false"
            :gridToggle="false" @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="cols">
          </bottom-navigation>
        </v-stepper-content>


      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Exercise saved</v-card-title>

        <v-card-text>Thank you for your participation</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import lodash from "lodash";
import { store } from "@/store";
// import draggable from "vuedraggable";
import { BottomNavigation, Imgx } from "@/components/core";
import TilesGridArranger from "@/views/user/exercises/tiles/TilesGridArranger";

const fb = require("@/firebaseConfig.js");

export default {
  name: "BrandTiles",
  data() {
    return {
      exercise: {
        firstName: "",
        lastName: "",
        jobTitle: ""
      },
      content: null,
      dragging: false,
      list: null,
      shortlist: [],
      gridSlots: [],
      gridCols: 4,
      gridCellSize: 120,
      valid: false,
      e1: 1,
      gridView: true,
      cols: 4,
      zoom: 7,
      rows: 4,
      filters: "All",
      dialog: false,
      categoryRules: [(v) => !!v || "Category is required"],
      regionRules: [(v) => !!v || "Region is required"],
      dropdownCategories: [
        "All",
        "Selected",
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
      ],
      userId: null,
      tilesUnsub: null,
      exerciseUnsub: null,
    };
  },
  components: {
    BottomNavigation,
    Imgx,
    TilesGridArranger
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "tiles", "currentProjectModel"]),
    computedWidh() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoom() {
      switch (this.zoom) {
        case 10:
          return "100%";
        case 9:
          return "50%";
        case 8:
          return "33.33%";
        case 7:
          return "25%";
        case 6:
          return "20%";
        case 5:
          return "16.666666666666667%";
        case 4:
          return "14.285714285714286%";
        case 3:
          return "12.5%";
        case 2:
          return "11.111111111111111%";
        case 1:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoomClass() {
      switch (this.zoom) {
        case 10:
        case 9:
        case 8:
        case 7:
        case 6:
          return "";
        default:
          return "smaller";
      }
    },
    computedRows() {
      return Math.ceil(this.shortlist.length / this.cols);
    },
    computedCells() {
      return this.cols * this.computedRows;
    },
    wordsCheck() {
      return this.selectedWords.length > 4 ? "red" : "grey darken-2";
    },
    imagesCheck() {
      return this.selectedImages.length > 16 ? "red" : "grey darken-2";
    },
    words() {
      if (this.list && this.list.length) {
        let list = this.list.filter((item) => item.type == "Word");
        return lodash.orderBy(list, "title", "asc");
      } else {
        return [];
      }
    },
    images() {
      if (this.list) {
        let arr = this.list.filter((item) => item.type == "Image");
        if (this.filters == "All") {
          return lodash.orderBy(arr, "id", "asc");
        } else if (this.filters == "Selected") {
          let filtered = this.shortlist.filter((item) => item.type == "Image");
          return lodash.orderBy(filtered, "title", "desc");
        } else {
          const filteredArr = arr.filter(
            (item) => item.category === this.filters
          );
          return lodash.orderBy(filteredArr, "id", "desc");
        }
      } else {
        return [];
      }
    },
    selectedImages() {
      if (this.shortlist) {
        let filtered = this.shortlist.filter((item) => item.type == "Image");
        return lodash.orderBy(filtered, "title", "desc");
      } else {
        return [];
      }
    },
    selectedWords() {
      if (this.shortlist) {
        const list = this.shortlist.filter((item) => item.type == "Word");
        return list.length >= 1 ? list : [];
      } else {
        return [];
      }
    },
  },

  async created() {
    // GET request using fetch with async/await
    console.log("loading content");
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  mounted() {
    this.$nextTick(() => {
      // 🔑 Initialise / retrieve anonymous user id from cookie
      this.initUserId();
      this.loadTiles();
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      if (!this.userId) {
        this.initUserId();
      }
      // tiles likely already in Vuex; just reload exercise
      this.getExercise();
    });
    next();
  },
  beforeDestroy() {
    if (this.tilesUnsub) {
      this.tilesUnsub();
      this.tilesUnsub = null;
    }
    if (this.exerciseUnsub) {
      this.exerciseUnsub();
      this.exerciseUnsub = null;
    }
  },

  methods: {
    // --- STEP NAV ---
    nextStep() {
      this.e1++;
      this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      this.saveExercise(false);
    },

    // --- DRAGGING ---
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById("tiles");
      div.children.forEach((doc) => {
        let item = this.shortlist.find((x) => x.id === doc.dataset.id);
        let indexOfItem = this.shortlist.indexOf(item);
        item.index = count;
        vm.$set(vm.shortlist, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    onUpdateCellConfig({ cols, cellSize }) {
      this.gridCols = cols;
      this.gridCellSize = cellSize;
    },
    // --- SHORTLIST / LIST HELPERS ---
    createShortlist() {
      let l = this.list.filter((item) => item.selected == true);
      this.shortlist = lodash.orderBy(l, "index", "asc");
    },
    loadShortlist() {
      if (this.exercise) {
        this.shortlist = this.exercise.selectedTiles || [];
      } else {
        this.shortlist = this.list.filter((item) => item.selected == true);
      }
    },
    updateShortList(item) {
      if (item.selected == true) {
        item.index = this.shortlist.length;
        this.shortlist.push(item);
      } else {
        let ref = this.shortlist.find((x) => x.id === item.id);
        let indexOfItem = this.shortlist.indexOf(ref);
        if (indexOfItem !== -1) {
          this.shortlist.splice(indexOfItem, 1);
        }
      }
      this.saveExercise(false);
    },
    createList() {
      let list = this.tiles;
      let count = 0;
      list.forEach((item) => {
        item.selected = this.checkId(item.id);
        item.index = count;
        count++;
      });
      this.list = list;
      this.createShortlist();
    },

    // --- FIREBASE LOADING ---
    loadTiles() {
      // if we already have a tiles listener, don't add another
      if (!this.tilesUnsub && this.tiles.length === 0) {
        this.tilesUnsub = fb.tilesCollection
          .orderBy("createdOn", "desc")
          .onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
              items.push(doc.data());
            });
            store.commit("setTiles", items);
            this.getExercise(); // tiles loaded -> now load exercise
          });
      } else {
        // tiles already in Vuex, just load exercise (but don't resub tiles)
        this.getExercise();
      }
    },
    checkId(id) {
      if (this.exercise) {
        let filteredList = this.exercise.selectedTiles.filter(
          (item) => item.id == id
        );
        return filteredList.length >= 1 ? true : false;
      } else {
        return false;
      }
    },
    selectCard(id) {
      let vm = this;
      let item = this.list.find((item) => item.id === id);
      let indexOfItem = this.list.indexOf(item);
      let truthy = item.selected;
      item.selected = !truthy;
      vm.$set(vm.list, indexOfItem, item);
      this.updateShortList(item);
    },

    getExercise() {
      if (!this.userId) return;

      // 🔹 if a previous exercise listener exists, remove it
      if (this.exerciseUnsub) {
        this.exerciseUnsub();
        this.exerciseUnsub = null;
      }

      const ref = fb[this.$route.meta.model]
        .where("uid", "==", this.userId)
        .where(
          "pid",
          "==",
          this.currentProjectModel && this.currentProjectModel.id
            ? this.currentProjectModel.id
            : "unknown"
        );

      this.exerciseUnsub = ref.onSnapshot((querySnapshot) => {
        let doc = null;
        querySnapshot.forEach((d) => {
          doc = d.data();
        });

        const base = {
          id: null,
          firstName: "",
          lastName: "",
          jobTitle: "",
          selectedTiles: [],
          cols: this.cols,
          step: 1,
          gridSlots: [],
        };

        this.exercise = Object.assign({}, base, doc || {});
        console.log("loaded exercise", this.exercise);

        this.shortlist = this.exercise.selectedTiles || [];
        this.cols = this.exercise.cols || this.cols;
        this.e1 = this.exercise.step || 1;

        // 🔹 hydrate arranger state
        this.gridSlots = this.exercise.gridSlots || [];
        this.gridCols = this.exercise.gridCols || 4;
        this.gridCellSize = this.exercise.cellSize || null;

        this.createList();
        this.loadShortlist();

        this.$nextTick(() => {
          if (this.$refs.detailsForm) {
            this.$refs.detailsForm.resetValidation();
            this.$refs.detailsForm.validate();
          }
        });
      });
    },

    // --- SECURE RANDOM STRING + COOKIES ---
    secureRandomString(length = 16) {
      // cryptographically secure random hex string
      const array = new Uint8Array(length);
      if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(array);
      } else {
        // fallback (not crypto secure, but rarely hit)
        for (let i = 0; i < length; i++) {
          array[i] = Math.floor(Math.random() * 256);
        }
      }
      return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
    },

    setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + d.toUTCString();
      document.cookie =
        name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? decodeURIComponent(match[2]) : null;
    },

    initUserId() {
      const cookieName = "tilesSurveyUid";
      let uid = this.getCookie(cookieName);
      if (!uid) {
        uid = this.secureRandomString(16);
        this.setCookie(cookieName, uid, 365); // 1 year
      }
      this.userId = uid;
      console.log("User ID (from cookie):", this.userId);
    },

    // --- SAVE EXERCISE ---
    saveExercise(notify) {
      let ref;
      let vm = this;

      if (!this.exercise || !this.exercise.id) {
        // new document
        ref = fb[this.$route.meta.model].doc();
      } else {
        // update existing
        ref = fb[this.$route.meta.model].doc(this.exercise.id);
      }

      ref
        .set({
          updatedOn: new Date(),
          id: ref.id,
          uid: this.userId,
          pid:
            this.currentProjectModel && this.currentProjectModel.id
              ? this.currentProjectModel.id
              : "unknown",
          selectedTiles: this.shortlist,
          cols: this.cols, // existing step-2/3 grid cols

          // details
          firstName: this.exercise.firstName || null,
          lastName: this.exercise.lastName || null,
          jobTitle: this.exercise.jobTitle || null,
          step: this.e1,

          // 🔹 Tiles arranger config
          gridSlots: this.gridSlots || [],
          gridCols: this.gridCols || 4,
          cellSize: this.gridCellSize || 120,
        })
        .then(() => {
          this.exercise.id = ref.id;
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: " + error);
        });
    },

    changeFilter(val) {
      this.filters = val;
    },
  },
};
</script>


<style lang="scss">
.canvas {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;

  &__tile {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-position: center;
    margin: 2px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
